import { useGetActivities } from 'api-hooks/activity';
import { NavigationRoutes } from 'common/constants';
import { capitalize } from 'common/utils/string';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function ActivityList() {
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);
  const { t } = useTranslation();

  const permission = useGetCrudPermission('activities');

  const _columns = React.useMemo(
    () => [
      {
        header: t('common:type'),
        accessorKey: 'type',
        minSize: 250,
        sortName: 'type',
        cell: ({ getValue }) => <>{capitalize(getValue()) as string}</>,
      },
      {
        header: t('common:code'),
        accessorKey: 'code',
        minSize: 250,
        sortName: 'code',
      },
      {
        header: t('common:name'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
      {
        header: t('common:email'),
        accessorKey: 'email',
        minSize: 180,
      },
      {
        header: t('cruise:tel_phone'),
        accessorKey: 'phone',
        minSize: 180,
      },
      {
        header: t('cruise:cellphone_number'),
        accessorKey: 'phone_2',
        minSize: 180,
      },

      {
        header: t('common:description'),
        accessorKey: 'description',
        minSize: 250,
        sortName: 'description',
      },
    ],
    [t],
  );

  return (
    <UniskaiListTemplate
      title={t(`pathname:${NavigationRoutes.ActivitiesList}`)}
      columns={_columns}
      page={page}
      setPage={setPage}
      useQuery={useGetActivities}
      queryInput={{
        params: {
          page,
        },
      }}
      tableName={NavigationRoutes.ActivitiesList}
      addNavigation={NavigationRoutes.ActivitiesCreate}
      rowLink={
        permission?.view
          ? (row) => ({
              pathname: NavigationRoutes.ActivitiesView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
